package com.yogaaicoach.pages.trainingprogram

import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

// Mirrors composeApp's DurationSerializer (common/network/serializers/DurationSerializer.kt)
// exactly — Duration is sent as a plain Int (minutes), not its enum name, since that's the wire
// format the backend expects. Lives in this package instead of composeApp's
// common.network.serializers to avoid a duplicate-FQN link error: composeApp's commonMain still
// has its own copy (its Duration enum is untouched), and both end up in the same jsMain bundle
// since composeApp depends on :core — same distinct-package collision-avoidance pattern already
// used for DashboardData.
object DurationSerializer : KSerializer<Duration> {
    override val descriptor: SerialDescriptor = PrimitiveSerialDescriptor("common.serializers.Duration", PrimitiveKind.INT)

    override fun serialize(encoder: Encoder, value: Duration) {
        encoder.encodeInt(value.minutes)
    }

    override fun deserialize(decoder: Decoder): Duration {
        val value = decoder.decodeInt()
        return Duration.entries.first { it.minutes == value }
    }
}
